import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { observe } from 'mobx'
import isNode from 'is-node'
import posed from 'react-pose'

import { BasketIcon } from 'src/components/UI/Icon/Icon'

import styles from './CartButton.module.scss'

const Icon = posed.div({
  attention: {
    scale: 1.05,
    transition: {
      type: 'spring',
      stiffness: 500,
      damping: 6,
    },
  },
  start: {
    scale: 0.8,
  },
  nothing: {
    scale: 1.01,
  },
})

type Props = {
  cart?: any
  ui?: any
  color: string
  inHeader?: boolean
}

@inject('cart')
@inject('ui')
@observer
class CartButton extends React.Component<Props> {
  disposer: any
  timer: null | any = null
  state = {
    start: false,
    animate: false,
  }

  constructor(props: Props) {
    super(props)
    const { cart } = this.props
    if (!isNode) {
      observe(cart, 'count', (change: any) => {
        if (change.oldValue < change.newValue) {
          if (!this.timer) {
            this.setState({
              start: true,
            })
            setTimeout(() => {
              this.setState({
                animate: true,
                start: false,
              })
            }, 80)
            this.timer = setTimeout(() => {
              this.setState({
                animate: false,
              })
              this.timer = null
            }, 800)
          }
        }
      })
    }
  }

  handleClick = () => {
    const { ui } = this.props
    ui.setActiveMenu(ui.activeMenu === 'cart' ? '' : 'cart')
  }

  render() {
    const { cart, color, inHeader } = this.props
    const { animate, start } = this.state

    const counterStyle = inHeader
      ? [styles.counter, styles.headerCounter].join(' ')
      : styles.counter

    return (
      <button
        className={styles.cartButton}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.handleClick}
      >
        <Icon pose={animate ? 'attention' : start ? 'start' : 'nothing'}>
          <BasketIcon width={24} height={24} color={color} />
          {cart.count !== 0 && (
            <div
              className={
                animate || start
                  ? [counterStyle, styles.animateCounter].join(' ')
                  : counterStyle
              }
            >
              <span>{cart.count}</span>
            </div>
          )}
        </Icon>
      </button>
    )
  }
}

export default CartButton
